import { z } from "zod";
import { IMPORT_MAX_RECORDS } from "./patient-import";

/**
 * Registro de agendamento normalizado pelo cliente.
 * patientName e date obrigatorios.
 */
export const appointmentImportRecordSchema = z.object({
  patientName: z.string().trim().min(1).max(200),
  patientPhone: z.string().trim().max(20).optional(),
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Data invalida (YYYY-MM-DD)"),
  startTime: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/).optional(),
  endTime: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/).optional(),
  procedure: z.string().trim().max(200).optional(),
  status: z.string().trim().max(50).optional(),
  notes: z.string().trim().max(2000).optional(),
  dentistName: z.string().trim().max(120).optional(),
  cancelled: z.boolean().optional(),
  color: z.string().regex(/^#[0-9A-Fa-f]{6}$/).optional(),
});
export type AppointmentImportRecord = z.infer<typeof appointmentImportRecordSchema>;

export const appointmentImportInputSchema = z.object({
  records: z
    .array(appointmentImportRecordSchema)
    .min(1)
    .max(IMPORT_MAX_RECORDS, `Máximo de ${IMPORT_MAX_RECORDS} registros por importação — divida o arquivo`),
  onlyFuture: z.boolean().default(true),
});
export type AppointmentImportInput = z.infer<typeof appointmentImportInputSchema>;

export type AppointmentImportResult = {
  created: number;
  skippedPast: number;
  patientsCreated: number;
  patientsMatched: number;
  errors: number;
  errorDetails: string[];
  totalProcessed: number;
};
